import tmhRequest from '@/config/tmhRequest'


export default {
    searchDevice: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/device/searchdevice',
            method: 'get',
            params: data,
        })
    },


    searchDeviceCount: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/device/searchdevicecount',
            method: 'post',
            data: data,
        })
    },
    searchDeviceByPage: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/device/searchdevicebypage',
            method: 'post',
            data: data,
        })
    },

    addDevice: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/device/adddevice',
            method: 'post',
            params: data,
        })
    },

    editDevice: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/device/editdevice',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/baseinfo/device.js